import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

/**
 * Trash button + confirm dialog (window.confirm is blocked inside the preview frame).
 * `onConfirm` is awaited; errors surface as a toast.
 */
export const DeleteButton = ({ testId, title, description, confirmLabel = "Delete", onConfirm, size = "md", label }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await onConfirm();
      setOpen(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not delete.");
    } finally {
      setBusy(false);
    }
  };
  const cls = label
    ? "h-9 px-3 rounded-full border border-[#e3e2dc] hover:border-[#ff2a85] hover:text-[#ff2a85] font-mono-d text-[9px] uppercase tracking-[0.2em] flex items-center gap-1.5 transition-colors"
    : size === "sm" ? "text-[#5f5e5a] hover:text-[#ff2a85] transition-colors p-1" : "h-9 w-9 rounded-full border border-[#e3e2dc] hover:border-[#ff2a85] hover:text-[#ff2a85] flex items-center justify-center transition-colors";
  return (
    <>
      <button type="button" data-testid={testId} onClick={(e) => { e.stopPropagation(); setOpen(true); }} aria-label={title} className={cls}>
        <Trash2 size={label ? 12 : size === "sm" ? 15 : 13} />{label}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid={`${testId}-dialog`} className="rounded-3xl max-w-md">
          <DialogHeader>
            <DialogTitle className="font-display font-extrabold uppercase">{title}</DialogTitle>
            <DialogDescription>{description}</DialogDescription>
          </DialogHeader>
          <div className="flex justify-end gap-2 pt-2">
            <button data-testid={`${testId}-cancel`} onClick={() => setOpen(false)} className="h-10 px-5 rounded-full border border-[#e3e2dc] hover:border-[#0a0a0b] text-xs">Keep</button>
            <button data-testid={`${testId}-confirm`} onClick={run} disabled={busy} className="h-10 px-5 rounded-full bg-[#ff2a85] hover:bg-[#e60067] text-white text-xs font-medium disabled:opacity-50 flex items-center gap-2">
              {busy && <Loader2 size={12} className="animate-spin" />} {confirmLabel}
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
